import React, { useContext, useEffect } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";
import MainStateContext from "../../state/mainStateContext";

export function AddressLine2Field(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  const { setValueChange } = formMethods;

  const { state } = useContext(MainStateContext);
  const { address } = state;

  useEffect(() => {
    setValueChange("address2", address.line2);
  }, [address.line2]);

  return (
    <InputControl
      fieldId="address2"
      fieldName="address2"
      fieldTitlePhraseKey="payment_step.field_labels.address2"
      fieldType="text"
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"sr-only"}
      formMethods={formMethods}
      isValid={true}
      optional={true}
      attributes={{
        disabled: disabled,
        autoCorrect: "off",
        autoComplete: "address-line2",
        "data-lpignore": "true"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.invalidChars, validators.maxLength(50)]}
    />
  );
}

export default AddressLine2Field;
